<div class="login">
  <div class="error-page">
    <div class="card">
      <!-- Login title -->
      <div class="card-header">
        <h5 class="login-title">
          <b>ArsonData Metering</b>
        </h5>
      </div>
      <div class="card-body text-center">
        <i class="fas fa-tools"></i>
        <h3>{{ "server-maintenance" | translate }}</h3>
        <h3>{{ "server-apologies" | translate }}</h3>
      </div>
    </div>
  </div>
</div>
